import React from 'react';
import './ContactPage.css';
import placeholder from "../../images/contact-placeholder.jpg";
// TODO: replace /api/contact with your real backend endpoint
const submitContactForm = async (formData: {
  name: string;
  email: string;
  phone: string;
  service: string;
  message: string;
}): Promise<boolean> => {
  try {
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    return res.ok;
  } catch {
    return false;
  }
};

export const ContactPage = ({isSubmitted, setIsSubmitted
  }: {isSubmitted: boolean; setIsSubmitted: (value: boolean) => void}) => {
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      
        const form = e.currentTarget;
        const formData = {
          name: (form.elements.namedItem('name') as HTMLInputElement).value,
          email: (form.elements.namedItem('email') as HTMLInputElement).value,
          phone: (form.elements.namedItem('phone') as HTMLInputElement).value,
          service: (form.elements.namedItem('Services') as HTMLSelectElement).value,
          message: (form.elements.namedItem('Message') as HTMLTextAreaElement).value,
        };
      
        const sent = await submitContactForm(formData);
        if (sent) {
          setIsSubmitted(true);
        } else {
          alert('Something went wrong. Please try again later.');
        }
      };
    
    return (
        <section id="contact">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Contact Us</span>
                    <h2 className="cs-title">Let's Get Your Freight Moving</h2>
                    {isSubmitted && <div className="cs-box-inline">
                        <div className="cs-flex">
                            <span className="cs-header">Thank you!<br/>We'll reach back to you shortly.</span>
                        </div>
                    </div>}
                    {!isSubmitted && <form className="cs-form" id="cs-form-323-2320" name="Contact Form" method="post" onSubmit = {handleSubmit}>
                        <label className="cs-label">
                            Name
                            <input className="cs-input" required type="text" name="name" placeholder="Name"/>
                        </label>
                        <label className="cs-label cs-email">
                            Email
                            <input className="cs-input" required type="email" name="email" placeholder="Email"/>
                        </label>
                        <label className="cs-label cs-phone">
                            Phone
                            <input className="cs-input" required type="tel" name="phone" placeholder="Phone"/>
                        </label>
                        <label className="cs-label cs-services">
                            Services
                            <select className="cs-input" name="Services">
                                <option value="" disabled selected>Select a Service</option>
                                <option value="Freight Transportation">Freight Transportation</option>
                                <option value="Warehouse & Storage">Warehouse & Storage</option>
                                <option value="Last-Mile Delivery">Last-Mile Delivery</option>
                                <option value="Custom Logistics Plan">Custom Logistics Plan</option>
                            </select>
                        </label>
                        <label className="cs-label">
                            Message
                            <textarea className="cs-input cs-textarea" required name="Message" placeholder="Write message..."></textarea>
                        </label>
                        <button className="cs-button-solid cs-submit" type="submit">Send Message</button>
                    </form>}
                </div>
                <div className="cs-map">
                    <div className="cs-iframe-wrapper">
                        <iframe title="Renuit Logistics office location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.938196485114!2d-82.64019952406225!3d27.770718476146442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e1834d3032bb%3A0xa8912a44583a5a6f!2s360%20Central%20Ave%2C%20St.%20Petersburg%2C%20FL%2033701!5e1!3m2!1sen!2sus!4v1749182224576!5m2!1sen!2sus" width="600" height="450" style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className="cs-box">
                        <img className="cs-icon" decoding="async" loading="lazy" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/yellow-pin.svg" alt="icon" width="40" height="40" aria-hidden="true"/>
                        <div className="cs-flex">
                            <span className="cs-header">Location</span>
                            <span className="cs-address">360 Central Avenue, Office #310, St. Petersburg, FL, 33701
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cs-container2">
                <picture className="cs-background">
                    <source media="(max-width: 600px)" srcSet={placeholder}/>
                    <source media="(min-width: 601px)" srcSet={placeholder}/>
                    <img loading="lazy" decoding="async" src={placeholder} alt="house" width="1280" height="243"/>
                </picture>
                <div className="cs-hours">
                    <div className="cs-topper">Working Hours</div>
                    <span className="cs-hours-info">Monday - Friday: 9:00 - 5:00 PM EST </span>
                </div>
            </div>
        </section>
  );
}
